import { render, staticRenderFns } from "./FourBanners.vue?vue&type=template&id=b1a6adfa&scoped=true&"
import script from "./FourBanners.vue?vue&type=script&lang=js&"
export * from "./FourBanners.vue?vue&type=script&lang=js&"
import style0 from "./FourBanners.vue?vue&type=style&index=0&id=b1a6adfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a6adfa",
  null
  
)

export default component.exports